// removed by extract-text-webpack-plugin
module.exports = {"alertRed":"src-components-Alerts-___index__alertRed___1392i","alertGreen":"src-components-Alerts-___index__alertGreen___1I-LV","alertRow":"src-components-Alerts-___index__alertRow___1TiVK","alertMessage":"src-components-Alerts-___index__alertMessage____BO05","alertLink":"src-components-Alerts-___index__alertLink___Ta7zz","alertImg":"src-components-Alerts-___index__alertImg___2MLZZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Alerts/index.css
// module id = 1297
// module chunks = 3